import {getLocale} from '$m7-library/utils/i18n.js';
import {waehrung} from './waehrung.js';

const currencyFormatter = new Intl.NumberFormat(getLocale(), {style: 'currency', currency: waehrung()});

export {currencyFormatter}
